// 电话
import Cook from "./cookie";

let phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

let englishPhoneReg = /^[0-9]+.?[0-9]*$/;

//密码验证 6-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种
let passwordReg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/;

//邮箱验证
let emailReg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;

//用户名校验
let userNameReg = /^[_\w\d]{6,20}$/;



import { language } from "../language/get";

import Cookie from "../common/cookie";

export function validatePhone(value){
  return phoneReg.test(value)
}
export function validateEmail(value){
  return emailReg.test(value)
}
/**
 * 区号校验
 * @param rule
 * @param value
 * @param callback
 * @returns {any}
 */
export function isAreaCode(rule, value, callback) {
  if (!value) {
    callback(new Error(language().areaCodeRules));
  }
  return isAreaCode;
}
/**
 * 手机号校验
 * @param rule
 * @param value
 * @param callback
 * @returns {any}
 */
export function isPhone(rule, value, callback) {
  if (!value) {
    callback(new Error(language().phoneRules));
  }
  // if (!phoneReg.test(value)) {
  if (typeof value != 'number') {
    callback(new Error(language().phoneCorrectlyRules));
  } else {
    callback();
  }
  return isPhone;
}
export function isPhone1(rule, value, callback) {
  if (!value) {
    callback(new Error(language().phoneRules));
  }else {
    callback();
  }
  return isPhone1;
}
/**
 * 英文手机号校验
 * @param rule
 * @param value
 * @param callback
 * @returns {any}
 */
export function isEnglishPhone(rule, value, callback) {
  if (!value) {
    callback(new Error(language().phoneRules));
  }
  // if (typeof value != 'number') {
  //   callback(new Error(language().phoneCorrectlyRules));
  // } else {
  //   callback();
  // }
    callback();
  return isEnglishPhone;
}

/**
 * 中英文登录
 * @param rule
 * @param value
 * @param callback
 * @returns {any}
 */
var lan = Cook.get("lang");
export function isLoginPhone(rule, value, callback) {
  if (!value) {
    callback(new Error(language().phoneLoginRules));
  }
  // if (lan == "ch" && !phoneReg.test(value)) {
  //   callback(new Error(language().phoneCorrectlyRules));
  // } else if (lan == "en" && !emailReg.test(value)) {
  //   callback(new Error(language().emailCorrectlyRules));
  // } else {
    callback();
  // }
  return isLoginPhone;
}



/**
 * 密码校验
 * @param rule
 * @param value
 * @param callback
 * @returns {any}
 */
export function isPassword(rule, value, callback) {
  if (!value) {
    callback(new Error(language().passwordRules));
  }
  // if (!passwordReg.test(value)) {
  //   callback(new Error(language().passwordCorrectlyRules));
  // }
  else {
    callback();
  }
  return isPassword;
}

/**
 * 邮箱校验
 * @param rule
 * @param value
 * @param callback
 * @returns {any}
 */
export function isEmail(rule, value, callback) {
  if (!value) {
    callback(new Error(language().emailRules));
  }
  if (!emailReg.test(value)) {
    callback(new Error(language().emailCorrectlyRules));
  } else {
    callback();
  }
  return isEmail;
}

/**
 * 用户名校验
 * @param rule
 * @param value
 * @param callback
 * @returns {any}
 */
export function isUser(rule, value, callback) {
  if (!value) {
    callback(new Error(language().userRules));
  }
  if (!userNameReg.test(value)) {
    callback(new Error(language().userCorrectlyRules));
  } else {
    callback();
  }
  return isUser;
}

/**
 * 是否为空
 * @param v
 * @returns {boolean}
 */
export function isEmpty(v) {
  switch (typeof v) {
    case 'undefined':
      return true;
    case 'string':
      if (v.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true;
      break;
    case 'boolean':
      if (!v) return true;
      break;
    case 'number':
      if (0 === v || isNaN(v)) return true;
      break;
    case 'object':
      if (null === v || v.length === 0) return true;
      for (var i in v) {
        return false;
      }
      return true;
  }
  return false;
}


/**
 * 判断是否为chrome浏览器
 * @returns {boolean}
 */
export function isInternet() {
  var agent = navigator.userAgent.toLowerCase();
  console.log(agent)
  var type = navigator.mimeTypes;
  for (let index = 0; index < type.length; index++) {
    console.log(type[index])
    if (type[index] == "application/360softmgrplugin") {
      return false
    }
  }
  if (agent.indexOf("qqbrowser") != -1) {
    return false;
  }
  if (agent.indexOf('chrome') > 0 || agent.indexOf("safari") > 0) {
    return true;
  }
  return false
}

